// extracted by mini-css-extract-plugin
export default {"loginPage":"styles_loginPage__rSoVk","loginContainer":"styles_loginContainer__1c1YG","companyInfo":"styles_companyInfo__UXkSn"};